import { BrandName } from 'src/@enums'

const baseLink = `${process.env.REACT_APP_RESOURCES_BASE_URL}/assets/images/brands`

export const getLogoImage = (brand: BrandName) => {
  const brandLink = `${baseLink}/${brand.toLowerCase()}`

  return {
    logo: `${brandLink}/logo.svg`,
    thumbnail: `${brandLink}/thumbnail.png`,
  }
}
